// Conversion events for standard analytics (plan Section 21). Data only: no reports are built here.
//
// Events: page_view, application_started, application_submitted, enquiry_submitted, phone_click, whatsapp_click.
// They go to Google Tag Manager's dataLayer and/or gtag when present, and are otherwise ignored, so the site works the
// same without analytics. Google Analytics 4 is loaded only when REACT_APP_GA_MEASUREMENT_ID is set at build time.
// Never pass personal data (names, emails, phone numbers) in event parameters.

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function track(event, params = {}) {
  try {
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...params });
    if (typeof window.gtag === 'function') window.gtag('event', event, params);
  } catch {
    // Analytics must never break the site.
  }
}

let installed = false;

// Loads GA4 if configured and records phone / WhatsApp link clicks anywhere on the site. Call once at start-up.
// Returns a function that removes the click listener (used by tests).
export function initAnalytics() {
  if (installed) return () => {};
  installed = true;

  if (MEASUREMENT_ID && /^G-[A-Z0-9]+$/i.test(MEASUREMENT_ID)) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    // Page views are sent by the router (single-page app), not automatically.
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
    document.head.appendChild(script);
  }

  const onClick = (e) => {
    const link = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const location = window.location.pathname;
    if (href.startsWith('tel:')) track('phone_click', { location });
    else if (/^https:\/\/wa\.me\//.test(href)) track('whatsapp_click', { location });
  };
  document.addEventListener('click', onClick, true);
  return () => {
    document.removeEventListener('click', onClick, true);
    installed = false;
  };
}

export const trackPageView = (path) => track('page_view', { page_path: path });
